import React from 'react'
// eslint-disable-next-line import/named
import SvgIcon, { SvgIconProps } from '@mui/material/SvgIcon'
import { COLORS } from '../styles/variables'

export const IconArrowDown: React.FC<SvgIconProps> = (props) => (
  <SvgIcon
    {...props}
    viewBox="0 0 12 8"
    sx={{
      color: COLORS.CERULEAN,
      width: 12, 
      height: 8,
      ...(props.sx || {}),
    }}
  >
    <path
      d="M11 1.51611L6.23553 6.48389L1.47107 1.51611"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
      fill="none"
    />
  </SvgIcon>
)
